import React, { useState, useEffect } from 'react';
/* global axios */
import api from '../services/apiService';
import { useParams, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';  // Import von React Helmet
import Select from 'react-select';
import moment from "moment";
import { useLiftworkerImport, LiftworkerImportButton, LiftworkerImportFeedback, LiftworkerDocumentPicker } from './LiftworkerImport';



const ItemForm = () => {
  const [insurancePercentage, setInsurancePercentage] = useState('');
  const [insurancePricingId, setInsurancePricingId] = useState(null);
  const [insuranceFixedAmount, setInsuranceFixedAmount] = useState('');
  const [insuranceFixedPricingId, setInsuranceFixedPricingId] = useState(null);
  const [editingPriceId, setEditingPriceId] = useState(null);
  const [editablePrice, setEditablePrice] = useState('');

  const [transportPrices, setTransportPrices] = useState([]);
  const [newTransportUnitId, setNewTransportUnitId] = useState('');
  const [newTransportPrice, setNewTransportPrice] = useState('');

  const [linkedItems, setLinkedItems] = useState([]); // Verknüpfte Artikel
  const [availableItems, setAvailableItems] = useState([]); // Alle verfügbaren Artikel
  const [newLinkItemId, setNewLinkItemId] = useState(''); // ID des neuen Artikels für die Verknüpfung
  const [machineTypes, setMachineTypes] = useState([]);
  const [machineTypeId, setMachineTypeId] = useState(''); // Immer eine leere Zeichenkette als Initialwert
  const { itemId } = useParams(); // Artikel-ID aus den Routenparametern holen
  const [units, setUnits] = useState([]);
  const navigate = useNavigate(); // Für Navigation

  const [activeTab, setActiveTab] = useState('general'); // Standardmäßig auf den "general"-Tab setzen
  const [showDateInput, setShowDateInput] = useState(false);


  // State für Formulardaten
  const [name, setName] = useState(''); // Initialisiert als leere Zeichenkette
  const [itemType, setItemType] = useState(''); // Initialisiert als leere Zeichenkette
  const [manufacturer, setManufacturer] = useState(''); // Initialisiert als leere Zeichenkette
  const [manufacturerType, setManufacturerType] = useState(''); // Initialisiert als leere Zeichenkette
  const [liftworkerId, setLiftworkerId] = useState(''); // Initialisiert als leere Zeichenkette
  const lwImport = useLiftworkerImport(liftworkerId, itemId);
  const [liftworkerType, setLiftworkerType] = useState(''); // Initialisiert als leere Zeichenkette
  const [accountingCodeId, setAccountingCodeId] = useState('');
  const [maxWorkingHeight, setMaxWorkingHeight] = useState(0); // Standardwert 0 für Zahlen
  const [basketArm, setBasketArm] = useState(false); // Boolean bleibt unverändert
  const [totalWeight, setTotalWeight] = useState(0); // Standardwert 0 für Zahlen
  const [yearOfManufacture, setYearOfManufacture] = useState(0); // Standardwert 0 für Zahlen
  const [serialNumber, setSerialNumber] = useState(''); // Initialisiert als leere Zeichenkette
  const [description, setDescription] = useState(''); // Initialisiert als leere Zeichenkette
  const [visibleInCalendar, setVisibleInCalendar] = useState(false); // Boolean bleibt unverändert
  const [foreignArticle, setForeignArticle] = useState(false); // Boolean bleibt unverändert
  const [deactivated, setDeactivated] = useState(false); // Boolean bleibt unverändert
  const [technicalDataOwner, setTechnicalDataOwner] = useState(''); // Initialisiert als leere Zeichenkette
  const [technicalDataManufacturer, setTechnicalDataManufacturer] = useState(''); // Initialisiert als leere Zeichenkette
  const [technicalDataSale, setTechnicalDataSale] = useState('');
  const [userManual, setUserManual] = useState(''); // Initialisiert als leere Zeichenkette
  const [errorCodes, setErrorCodes] = useState(''); // Initialisiert als leere Zeichenkette
  const [productGroupId, setProductGroupId] = useState(''); // Immer eine leere Zeichenkette
  const [motorTypeId, setMotorTypeId] = useState(''); // Immer eine leere Zeichenkette
  const [uvvInspection, setUvvInspection] = useState(''); // Initialisiert als leere Zeichenkette
  const [tuvInspection, setTuvInspection] = useState(''); // Initialisiert als leere Zeichenkette
  const [tachoInspection, setTachoInspection] = useState(''); // Initialisiert als leere Zeichenkette
  const [asuInspection, setAsuInspection] = useState(''); // Initialisiert als leere Zeichenkette
  const [otherInspection, setOtherInspection] = useState(''); // Initialisiert als leere Zeichenkette
  const [licensePlate, setLicensePlate] = useState(''); // Initialisiert als leere Zeichenkette
  const [inventoryNumber, setInventoryNumber] = useState(''); // Initialisiert als leere Zeichenkette
  const [cargo, setCargo] = useState(''); // Initialisiert als leere Zeichenkette
  const [splitCargo, setSplitCargo] = useState(''); // Initialisiert als leere Zeichenkette
  const [driverLicense, setDriverLicense] = useState(''); // Initialisiert als leere Zeichenkette
  const [calcCostPerDay, setcalcCostPerDay] = useState(0); // Standardwert 0 für Zahlen
  const [technicalDataUrl, setTechnicalDataUrl] = useState('');
  const [qsv1Url, setQsv1Url] = useState(''); // Initialisiert als leere Zeichenkette
  const [qsv2Url, setQsv2Url] = useState(''); // Initialisiert als leere Zeichenkette
  const [qsv3Url, setQsv3Url] = useState(''); // Initialisiert als leere Zeichenkette
  const [uvvInspectionUrl, setUvvInspectionUrl] = useState(''); // Initialisiert als leere Zeichenkette
const [tuvInspectionUrl, setTuvInspectionUrl] = useState(''); // Initialisiert als leere Zeichenkette
const [tachoInspectionUrl, setTachoInspectionUrl] = useState(''); // Initialisiert als leere Zeichenkette
const [asuInspectionUrl, setAsuInspectionUrl] = useState(''); // Initialisiert als leere Zeichenkette
const [otherInspectionUrl, setOtherInspectionUrl] = useState(''); // Initialisiert als leere Zeichenkette
const [workinghour, setWorkinghour] = useState('');       // neues Feld
const [conditionId, setConditionId] = useState('');  
const [articleOptions, setArticleOptions] = useState([]);
const [selectedArticle, setSelectedArticle] = useState(null);
const [notes, setNotes] = useState('');
// --- NEU: Finanz-/Meta-Felder ---
const [acquisitionCost, setAcquisitionCost] = useState('');
const [insuranceCost, setInsuranceCost] = useState('');
const [kfzTax, setKfzTax] = useState('');
const [budgetPricePerDay, setBudgetPricePerDay] = useState('');
const [costPricePerDay, setCostPricePerDay] = useState('');
const [stockQuantity, setStockQuantity] = useState('');
const [financingCostPerMonth, setFinancingCostPerMonth] = useState('');
const [financingUntil, setFinancingUntil] = useState(''); // YYYY-MM-DD
const [color, setColor] = useState('');

const [telematicsProviders, setTelematicsProviders] = useState([]);
const [telematicsProviderId, setTelematicsProviderId] = useState('');
const [telematicsExternalUnitId, setTelematicsExternalUnitId] = useState('');
const [hasTelematicsConfig, setHasTelematicsConfig] = useState(false);



// ⬇️ NEU: Helper, um Weiß (#fff, #ffffff, #ffffffff) zu erkennen
const isWhite = (hex) => /^#?f{3,8}$/i.test((hex || '').replace('#', ''));


  // Neue States für den Export-Tab
  const [exportLO, setExportLO] = useState(false);
  const [netPriceLO, setNetPriceLO] = useState('');
  const [notesLO, setNotesLO] = useState('');
  const [picLO, setPicLO] = useState('');
  const [locationLO, setLocationLO] = useState('');

  const [exportSRR, setExportSRR] = useState(false);
  const [netPricePerDaySRR1, setNetPricePerDaySRR1] = useState('');
  const [netPricePerDaySRR2, setNetPricePerDaySRR2] = useState('');
  const [netPricePerDaySRR3, setNetPricePerDaySRR3] = useState('');
  const [netPricePerDaySRR4, setNetPricePerDaySRR4] = useState('');
  const [netPricePerHourSRR, setNetPricePerHourSRR] = useState('');
  const [notesSRR, setNotesSRR] = useState('');
  const [picSRR, setPicSRR] = useState('');
  const [locationSRR, setLocationSRR] = useState('');

  const [picHP, setPicHP] = useState('');
  

  // Neue States für Sales-Pricing
  const [salesPricings, setSalesPricings] = useState([]);
  const [newSalesUnitId, setNewSalesUnitId] = useState('');
  const [newSalesMinQuantity, setNewSalesMinQuantity] = useState('');
  const [newSalesMaxQuantity, setNewSalesMaxQuantity] = useState('');
  const [newSalesPrice, setNewSalesPrice] = useState('');
  const [editingSalesPriceId, setEditingSalesPriceId] = useState(null);
  const [editableSalesUnitId, setEditableSalesUnitId] = useState('');
  const [editableSalesMinQuantity, setEditableSalesMinQuantity] = useState('');
  const [editableSalesMaxQuantity, setEditableSalesMaxQuantity] = useState('');
  const [editableSalesPrice, setEditableSalesPrice] = useState('');

// States für das neue Select/Freitext‑Feld
const [locationOptionsSRR, setLocationOptionsSRR] = useState([]);
const [locationOptionsLO, setLocationOptionsLO] = useState([]);
const [customLocationSRR, setCustomLocationSRR] = useState('');
const [useCustomLocationSRR, setUseCustomLocationSRR] = useState(false);
const [customLocationLO, setCustomLocationLO] = useState('');
const [useCustomLocationLO, setUseCustomLocationLO] = useState(false);
const [conditions, setConditions] = useState([]);    
const [accountingCodes, setAccountingCodes] = useState([]);
const [storageLocations, setStorageLocations] = useState([]);
const [storageLocationId, setStorageLocationId] = useState('');

const getUnitIdByName = (name) => units.find(u => u.name === name)?.id;








// zeigt "1,23" oder "-" wenn kein gültiger Wert vorhanden ist
const formatPrice = (v) => {
  const n = Number(v);
  return Number.isFinite(n) ? n.toFixed(2).replace('.', ',') : '-';
};

const sortSalesPricings = (list) => {
  return [...list].sort((a, b) => {
    // 1. Nach Einheit (unitId)
    if (a.unitId !== b.unitId) return a.unitId - b.unitId;
    // 2. Nach minQuantity
    if (a.minQuantity !== b.minQuantity) return a.minQuantity - b.minQuantity;
    // 3. Nach maxQuantity
    return a.maxQuantity - b.maxQuantity;
  });
};

useEffect(() => {
  // Sobald sich der Artikeltyp ändert, passende Felder zurücksetzen
  if (itemType !== 'insurance') {
    setInsurancePercentage('');
    setInsurancePricingId(null);
  }
  if (itemType !== 'insuranceFixed') {
    setInsuranceFixedAmount('');
    setInsuranceFixedPricingId(null);
  }
}, [itemType]);



const toDateOnly = (isoOrDateString) => {
    if (!isoOrDateString) return null;
    return isoOrDateString.split("T")[0];
  };

  useEffect(() => {
    if (!itemId) {
      // Reset aller States für ein neues Item
      setName('');
      setItemType('');
      setMachineTypeId('');
      setManufacturer('');
      setManufacturerType('');
      setLiftworkerId('');
      setLiftworkerType('');
      setAccountingCodeId('');
      setStorageLocationId('');
      setMaxWorkingHeight(0);
      setBasketArm(false);
      setTotalWeight(0);
      setYearOfManufacture(0);
      setSerialNumber('');
      setDescription('');
      setVisibleInCalendar(false);
      setForeignArticle(false);
      setDeactivated(false);
      setProductGroupId('');
      setMotorTypeId('');
      setUvvInspection('');
      setTuvInspection('');
      setTachoInspection('');
      setAsuInspection('');
      setOtherInspection('');
      setTechnicalDataOwner('');
      setTechnicalDataManufacturer('');
      setTechnicalDataSale('');
      setUserManual('');
      setErrorCodes('');
      setInsurancePercentage('');
      setInsurancePricingId(null);
      setTransportPrices([]);
      setSalesPricings([]);
      setLinkedItems([]);
      setLicensePlate('');
      setInventoryNumber('');
      setCargo(0);
      setSplitCargo(0);
      setDriverLicense('');
      setcalcCostPerDay(0);
      // Ebenso neue Export-Felder zurücksetzen
      setExportLO(false);
      setNetPriceLO('');
      setNotesLO('');
      setPicLO('');
      setLocationLO('');
      setExportSRR(false);
      setNetPricePerDaySRR1('');
      setNetPricePerDaySRR2('');
      setNetPricePerDaySRR3('');
      setNetPricePerDaySRR4('');
      setNetPricePerHourSRR('');
      setNotesSRR('');
      setPicSRR('');
      setLocationSRR('');
      setPicHP('');
      setQsv1Url('');
      setQsv2Url('');
      setQsv3Url('');
      setUvvInspectionUrl('');
      setTuvInspectionUrl('');
      setTachoInspectionUrl('');
      setAsuInspectionUrl('');
      setOtherInspectionUrl('');
      setWorkinghour('');
      setConditionId('');
      setNotes('');
      // --- NEU: Reset der Finanz-/Meta-Felder ---
setAcquisitionCost('');
setInsuranceCost('');
setKfzTax('');
setBudgetPricePerDay('');
setCostPricePerDay('');
setStockQuantity('');
setFinancingCostPerMonth('');
setFinancingUntil('');
setColor('');
setTelematicsProviders([]);
setTelematicsProviderId('');
setTelematicsExternalUnitId('');
setHasTelematicsConfig(false);
    }
  }, [itemId]); // Dieser Effekt läuft, wenn sich itemId ändert

// Filtert Deine items nach dem Eingabetext und wandelt sie in react-select-Options um
const handleArticleSearchChange = (inputValue) => {
  // z.B. alle verfügbaren Items lokal filtern:
  const filtered = availableItems
    .filter(item => item.name.toLowerCase().includes(inputValue.toLowerCase()))
    .map(item => ({ value: item.id, label: `${item.name} (${item.itemType})` }));
  setArticleOptions(filtered);
};

// Setzt beim Klick auf einen Eintrag die ID in Dein Formular
const handleArticleChange = (option) => {
  setSelectedArticle(option);
  setNewLinkItemId(option ? option.value : '');
};


 // Transportpreise laden
useEffect(() => {
  if (itemId && itemType === 'transport') {
    fetchTransportPrices();
  }
}, [itemId, itemType]);

const fetchTransportPrices = () => {
  if (itemId && itemType === 'transport') {
    api.get(`/transportpricings/${itemId}`)
      .then((response) => setTransportPrices(response.data))
      .catch((error) => console.error('Fehler beim Laden der Transportpreise:', error));
  }
};

const addTransportPrice = () => {
  if (!newTransportUnitId || !newTransportPrice) {
    alert('Bitte Einheit und Preis eingeben.');
    return;
  }

  api.post('/transportpricings', {
    itemId,
    unitId: newTransportUnitId,
    pricePerUnit: parseFloat(newTransportPrice),
  })
    .then((response) => {
      setTransportPrices((prev) => [...prev, response.data]);
      setNewTransportUnitId('');
      setNewTransportPrice('');
      alert('Preis erfolgreich hinzugefügt!');
    })
    .catch((error) => console.error('Fehler beim Hinzufügen des Preises:', error));
};

const deleteTransportPrice = (priceId) => {
  api.delete(`/transportpricings/${priceId}`)
    .then(() => {
      setTransportPrices((prev) => prev.filter((price) => price.id !== priceId));
      alert('Preis erfolgreich gelöscht!');
    })
    .catch((error) => console.error('Fehler beim Löschen des Preises:', error));
};

const saveTransportPrice = (id) => {
  api
    .put(`/transportpricings/${id}`, { pricePerUnit: editablePrice })
    .then(() => {
      fetchTransportPrices(); // Aktualisiert die Preisliste
      cancelEdit();
    })
    .catch((err) => console.error('Fehler beim Speichern:', err));
};

const cancelEdit = () => {
  setEditingPriceId(null);
  setEditablePrice('');
};

const startEdit = (id, price) => {
  setEditingPriceId(id);
  setEditablePrice(price);
};

const openTechnicalDataUrl = () => {
  if (!technicalDataOwner) {
    alert('Bitte zuerst eine URL in das Feld "Techn. Daten (Verm)" eintragen.');
    return;
  }
  let url = technicalDataOwner;
  if (!/^https?:\/\//i.test(url)) {
    url = 'http://' + url;
  }
  window.open(url, '_blank');
};

const openTechnicalDataManufacturerUrl = () => {
  if (!technicalDataManufacturer) {
    alert('Bitte zuerst eine URL in das Feld "Techn. Daten (Herst)" eintragen.');
    return;
  }
  let url = technicalDataManufacturer;
  if (!/^https?:\/\//i.test(url)) {
    url = 'http://' + url;
  }
  window.open(url, '_blank');
};

const openTechnicalDataSaleUrl = () => {
  if (!technicalDataSale) {
    alert('Bitte zuerst eine URL in das Feld "Techn. Daten (Verkauf)" eintragen.');
    return;
  }
  let url = technicalDataSale;
  if (!/^https?:\/\//i.test(url)) {
    url = 'http://' + url;
  }
  window.open(url, '_blank');
};

const openUserManualUrl = () => {
  if (!userManual) {
    alert('Bitte zuerst eine URL in das Feld "Bedienungsanleitung" eintragen.');
    return;
  }
  let url = userManual;
  if (!/^https?:\/\//i.test(url)) {
    url = 'http://' + url;
  }
  window.open(url, '_blank');
};

const openErrorCodesUrl = () => {
  if (!errorCodes) {
    alert('Bitte zuerst eine URL in das Feld "Fehlercodes" eintragen.');
    return;
  }
  let url = errorCodes;
  if (!/^https?:\/\//i.test(url)) {
    url = 'http://' + url;
  }
  window.open(url, '_blank');
};

const openQsv1Url = () => {
  if (!qsv1Url) {
    alert('Bitte zuerst eine URL in das Feld "qsv1Url" eintragen.');
    return;
  }
  let url = qsv1Url;
  if (!/^https?:\/\//i.test(url)) {
    url = 'http://' + url;
  }
  window.open(url, '_blank');
};

const openQsv2Url = () => {
  if (!qsv2Url) {
    alert('Bitte zuerst eine URL in das Feld "qsv2Url" eintragen.');
    return;
  }
  let url = qsv2Url;
  if (!/^https?:\/\//i.test(url)) {
    url = 'http://' + url;
  }
  window.open(url, '_blank');
};

const openQsv3Url = () => {
  if (!qsv3Url) {
    alert('Bitte zuerst eine URL in das Feld "qsv3Url" eintragen.');
    return;
  }
  let url = qsv3Url;
  if (!/^https?:\/\//i.test(url)) {
    url = 'http://' + url;
  }
  window.open(url, '_blank');
};

const openPicHPUrl = () => {
  if (!picHP) {
    alert('Bitte zuerst eine URL in das Feld "picHP" eintragen.');
    return;
  }
  let url = picHP;
  if (!/^https?:\/\//i.test(url)) {
    url = 'http://' + url;
  }
  window.open(url, '_blank');
};

const openUvvInspectionUrl = () => {
  if (!uvvInspectionUrl) {
    alert('Bitte zuerst eine URL in das Feld "uvvInspectionUrl" eintragen.');
    return;
  }
  let url = uvvInspectionUrl;
  if (!/^https?:\/\//i.test(url)) {
    url = 'http://' + url;
  }
  window.open(url, '_blank');
};

const openTuvInspectionUrl = () => {
  if (!tuvInspectionUrl) {
    alert('Bitte zuerst eine URL in das Feld "tuvInspectionUrl" eintragen.');
    return;
  }
  let url = tuvInspectionUrl;
  if (!/^https?:\/\//i.test(url)) {
    url = 'http://' + url;
  }
  window.open(url, '_blank');
};

const openTachoInspectionUrl = () => {
  if (!tachoInspectionUrl) {
    alert('Bitte zuerst eine URL in das Feld "tachoInspectionUrl" eintragen.');
    return;
  }
  let url = tachoInspectionUrl;
  if (!/^https?:\/\//i.test(url)) {
    url = 'http://' + url;
  }
  window.open(url, '_blank');
};

const openAsuInspectionUrl = () => {
  if (!asuInspectionUrl) {
    alert('Bitte zuerst eine URL in das Feld "asuInspectionUrl" eintragen.');
    return;
  }
  let url = asuInspectionUrl;
  if (!/^https?:\/\//i.test(url)) {
    url = 'http://' + url;
  }
  window.open(url, '_blank');
};

const openOtherInspectionUrl = () => {
  if (!otherInspectionUrl) {
    alert('Bitte zuerst eine URL in das Feld "otherInspectionUrl" eintragen.');
    return;
  }
  let url = otherInspectionUrl;
  if (!/^https?:\/\//i.test(url)) {
    url = 'http://' + url;
  }
  window.open(url, '_blank');
};



// Hinzufügen eines neuen Sales-Pricings
const addSalesPricing = () => {
  if (!newSalesUnitId || !newSalesMinQuantity || !newSalesMaxQuantity || !newSalesPrice) {
    alert('Bitte alle Felder für das neue Sales-Pricing ausfüllen.');
    return;
  }

  api.post('/salespricings', {
    itemId: itemId,
    unitId: newSalesUnitId,
    minQuantity: parseInt(newSalesMinQuantity, 10),
    maxQuantity: parseInt(newSalesMaxQuantity, 10),
    pricePerUnit: parseFloat(newSalesPrice),
  })
    .then((response) => {
      setSalesPricings((prev) => sortSalesPricings([...prev, response.data]));
      setNewSalesUnitId('');
      setNewSalesMinQuantity('');
      setNewSalesMaxQuantity('');
      setNewSalesPrice('');
      alert('Sales-Pricing erfolgreich hinzugefügt!');
    })
    .catch((error) => {
      console.error('Fehler beim Hinzufügen des Sales-Pricings:', error);
      alert('Fehler beim Hinzufügen des Sales-Pricings.');
    });
};

// Starten des Bearbeitens eines Sales-Pricings
const startEditSalesPricing = (id, unitId, minQuantity, maxQuantity, pricePerUnit) => {
  setEditingSalesPriceId(id);
  setEditableSalesUnitId(unitId);
  setEditableSalesMinQuantity(minQuantity);
  setEditableSalesMaxQuantity(maxQuantity);
  setEditableSalesPrice(pricePerUnit);
};

// Speichern des bearbeiteten Sales-Pricings
const saveSalesPricing = (id) => {
  if (!editableSalesUnitId || !editableSalesMinQuantity || !editableSalesMaxQuantity || !editableSalesPrice) {
    alert('Bitte alle Felder für das Sales-Pricing ausfüllen.');
    return;
  }

  api.put(`/salespricings/${id}`, {
    unitId: editableSalesUnitId,
    minQuantity: parseInt(editableSalesMinQuantity, 10),
    maxQuantity: parseInt(editableSalesMaxQuantity, 10),
    pricePerUnit: parseFloat(editableSalesPrice),
  })
    .then(() => {
   setSalesPricings(prev =>
    sortSalesPricings(
     prev.map(p =>
       p.id === id
         ? {
             ...p,
             unitId: Number(editableSalesUnitId),
             minQuantity: parseInt(editableSalesMinQuantity, 10),
             maxQuantity: parseInt(editableSalesMaxQuantity, 10),
             pricePerUnit: Number(editableSalesPrice) // 👈 direkt setzen
           }
         : p
     )
      )
   );
      setEditingSalesPriceId(null);
      setEditableSalesUnitId('');
      setEditableSalesMinQuantity('');
      setEditableSalesMaxQuantity('');
      setEditableSalesPrice('');
      alert('Sales-Pricing erfolgreich aktualisiert!');
    })
    .catch((error) => {
      console.error('Fehler beim Aktualisieren des Sales-Pricings:', error);
      alert('Fehler beim Aktualisieren des Sales-Pricings.');
    });
};

// Abbrechen des Bearbeitens eines Sales-Pricings
const cancelEditSalesPricing = () => {
  setEditingSalesPriceId(null);
  setEditableSalesUnitId('');
  setEditableSalesMinQuantity('');
  setEditableSalesMaxQuantity('');
  setEditableSalesPrice('');
};

// Löschen eines Sales-Pricings
const deleteSalesPricing = (id) => {
  if (!window.confirm('Bist du sicher, dass du dieses Sales-Pricing löschen möchtest?')) {
    return;
  }

  api.delete(`/salespricings/${id}`)
    .then(() => {
      setSalesPricings(salesPricings.filter((price) => price.id !== id));
      alert('Sales-Pricing erfolgreich gelöscht!');
    })
    .catch((error) => {
      console.error('Fehler beim Löschen des Sales-Pricings:', error);
      alert('Fehler beim Löschen des Sales-Pricings.');
    });
};


// direkt in einem useEffect neben den anderen List-Ladern
useEffect(() => {
  api.get('/conditions')
     .then(res => setConditions(res.data))
     .catch(err => console.error('Fehler beim Laden der Conditions:', err));
}, []);

useEffect(() => {
  api.get('/accountingcodes')
     .then(res => setAccountingCodes(res.data))
     .catch(err => console.error('Fehler beim Laden der Buchungskonten:', err));
}, []);

useEffect(() => {
  api.get('/storage-locations')
    .then(res => setStorageLocations(res.data || []))
    .catch(err => console.error('Fehler beim Laden der Lagerorte:', err));
}, []);



  // Verknüpfte Artikel laden
useEffect(() => {
  if (itemId) {
    api.get(`/itemlinks/${itemId}`)
      .then((response) => setLinkedItems(response.data))
      .catch((error) => console.error('Fehler beim Laden der Verknüpfungen:', error));
  }
}, [itemId]);

// Alle verfügbaren Artikel laden
useEffect(() => {
  api.get('/items')
    .then((response) => setAvailableItems(response.data))
    .catch((error) => console.error('Fehler beim Laden der Artikel:', error));
}, []);

// Neue Verknüpfung hinzufügen
const addLink = () => {
  if (!newLinkItemId || !itemId) return;

  api.post('/itemlinks', { parentItemId: itemId, linkedItemId: newLinkItemId })
    .then(() => {
      api.get(`/itemlinks/${itemId}`) // Liste aktualisieren
        .then((response) => setLinkedItems(response.data))
        .catch((error) => console.error('Fehler beim Aktualisieren der Verknüpfungen:', error));
    })
    .catch((error) => console.error('Fehler beim Hinzufügen der Verknüpfung:', error));
};

// Verknüpfung entfernen
const removeLink = (linkId) => {
  api.delete(`/itemlinks/${linkId}`)
    .then(() => {
      setLinkedItems((prevLinks) => prevLinks.filter((link) => link.id !== linkId)); // Liste aktualisieren
    })
    .catch((error) => console.error('Fehler beim Entfernen der Verknüpfung:', error));
};



  // State für Listen
  const [productGroups, setProductGroups] = useState([]); // Initialisiert als leeres Array
  const [motorTypes, setMotorTypes] = useState([]); // Initialisiert als leeres Array

  // State für Preise
  const [prices, setPrices] = useState([]);


  // Lade Maschinentypen beim Initialisieren der Komponente
  useEffect(() => {
    const fetchMachineTypes = async () => {
      try {
        const response = await api.get('/machine-types');
        setMachineTypes(response.data);
      } catch (error) {
        console.error('Fehler beim Abrufen der Maschinentypen:', error);
      }
    };

    fetchMachineTypes();
  }, []);

  // Laden der Produktgruppen und Motorisierungen
  useEffect(() => {
    api.get('/product-groups')
      .then(response => setProductGroups(response.data))
      .catch(error => console.error('Fehler beim Laden der Produktgruppen:', error));

    api.get('/motorTypes')
      .then(response => setMotorTypes(response.data))
      .catch(error => console.error('Fehler beim Laden der Motorisierungen:', error));
  }, []);


  // Telematik-Provider laden
useEffect(() => {
  api.get('/telematics/providers')
    .then(res => {
      const list = Array.isArray(res.data) ? res.data : (res.data.data || []);
      setTelematicsProviders(list);
    })
    .catch(err => {
      console.error('Fehler beim Laden der Telematik-Provider:', err);
    });
}, []);




// Wenn eine `itemId` existiert, Artikel-Daten laden
useEffect(() => {
  if (itemId) {
    api
      .get(`/items/${itemId}`)
      .then(async (response) => {
        const item = response.data;
        setName(item.name);
        setItemType(item.itemType);
        setMachineTypeId(item.machineTypeId); // Vorhandenen Maschinentyp setzen
        setManufacturer(item.manufacturer);
        setManufacturerType(item.manufacturerType);
        setLiftworkerId(item.liftworkerId);
        setLiftworkerType(item.liftworkerType);
        setAccountingCodeId(item.accountingCodeId || '');
        setStorageLocationId(item.storageLocationId || '');
        setMaxWorkingHeight(item.maxWorkingHeight);
        setBasketArm(item.basketArm);
        setTotalWeight(item.totalWeight);
        setYearOfManufacture(item.yearOfManufacture);
        setSerialNumber(item.serialNumber);
        setDescription(item.description);
        setVisibleInCalendar(item.visibleInCalendar);
        setForeignArticle(item.foreignArticle);
        setDeactivated(item.deactivated);
        setTechnicalDataOwner(item.technicalDataOwner);
        setTechnicalDataManufacturer(item.technicalDataManufacturer);
        setTechnicalDataSale(item.technicalDataSale);
        setUserManual(item.userManual);
        setErrorCodes(item.errorCodes);
        setProductGroupId(item.productGroupId);
        setMotorTypeId(item.motorTypeId);
        setUvvInspection(   toDateOnly(item.uvvInspection)   );
          setTuvInspection(   toDateOnly(item.tuvInspection)   );
          setTachoInspection( toDateOnly(item.tachoInspection) );
          setAsuInspection(   toDateOnly(item.asuInspection)   );
          setOtherInspection( toDateOnly(item.otherInspection) );
        setLicensePlate(item.licensePlate);
        setInventoryNumber(item.inventoryNumber);
        setCargo(item.cargo);
        setSplitCargo(item.splitCargo);
        setDriverLicense(item.driverLicense);
        setcalcCostPerDay(item.calcCostPerDay);
         // Neue Export-Daten setzen:
         setExportLO(item.exportLO || false);
         setNetPriceLO(item.netPriceLO || ''); // Falls der Wert null ist, auf leeren String setzen
         setNotesLO(item.notesLO || '');
         setPicLO(item.picLO || '');
         setLocationLO(item.locationLO || '');
         setLocationOptionsLO(response.data.locationOptionsLO || []);
 
         setExportSRR(item.exportSRR || false);
         setNetPricePerDaySRR1(item.netPricePerDaySRR1 || '');
         setNetPricePerDaySRR2(item.netPricePerDaySRR2 || '');
         setNetPricePerDaySRR3(item.netPricePerDaySRR3 || '');
         setNetPricePerDaySRR4(item.netPricePerDaySRR4 || '');
         setNetPricePerHourSRR(item.netPricePerHourSRR || '');
         setNotesSRR(item.notesSRR || '');
         setPicSRR(item.picSRR || '');
         setLocationSRR(item.locationSRR || '');
         setLocationOptionsSRR(response.data.locationOptionsSRR || []);
 
         setPicHP(item.picHP || '');

         setQsv1Url(item.qsv1Url || '');
         setQsv2Url(item.qsv2Url || '');
         setQsv3Url(item.qsv3Url || '');

         setUvvInspectionUrl(item.uvvInspectionUrl);
         setTuvInspectionUrl(item.tuvInspectionUrl);
         setTachoInspectionUrl(item.tachoInspectionUrl);
         setAsuInspectionUrl(item.asuInspectionUrl);
         setOtherInspectionUrl(item.otherInspectionUrl);
         setWorkinghour(item.workinghour != null ? item.workinghour : '');
          setConditionId(item.conditionId != null ? item.conditionId : '');
         setNotes(item.notes || '');
         // --- NEU: Finanz-/Meta-Felder aus Backend setzen ---
setAcquisitionCost(item.acquisitionCost ?? '');
setInsuranceCost(item.insuranceCost ?? '');
setKfzTax(item.kfzTax ?? '');
setBudgetPricePerDay(item.budgetPricePerDay ?? '');
setCostPricePerDay(item.costPricePerDay ?? '');
setStockQuantity(item.stockQuantity ?? '');
setFinancingCostPerMonth(item.financingCostPerMonth ?? '');
setFinancingUntil(toDateOnly(item.financingUntil) || '');
setColor(item.color ?? '');

        // Versicherungspreis laden
        if (item.itemType === 'insurance') {
          try {
            const insuranceResponse = await api.get(`/insurancepricings/${itemId}`);
            if (insuranceResponse.data.length > 0) {
              const insuranceData = insuranceResponse.data[0];
              setInsurancePercentage(insuranceData.percentage);
              setInsurancePricingId(insuranceData.id); // Speichert die ID, falls später aktualisiert wird
            } else {
              setInsurancePercentage(''); // Kein Prozentsatz gefunden
              setInsurancePricingId(null); // Kein existierender Eintrag
            }
          } catch (error) {
            console.error('Fehler beim Laden des Versicherungspreises:', error);
          }
        }

        // InsuranceFixed-Feld laden
if (item.itemType === 'insuranceFixed') {
  try {
    const insuranceResponse = await api.get(`/insurancepricings/${itemId}`);
    if (insuranceResponse.data.length > 0) {
      const insuranceData = insuranceResponse.data[0];
      setInsuranceFixedAmount(insuranceData.fixedAmount ?? '');
      setInsuranceFixedPricingId(insuranceData.id);
    } else {
      setInsuranceFixedAmount('');
      setInsuranceFixedPricingId(null);
    }
  } catch (error) {
    console.error('Fehler beim Laden des Versicherungspreises:', error);
  }
}

        // Sales-Pricing laden für bestimmte Item-Typen
        if (['sale', 'sparePart', 'service'].includes(item.itemType)) {
          try {
            const salesResponse = await api.get(`/salespricings/${itemId}`);
            setSalesPricings(sortSalesPricings(salesResponse.data));
          } catch (error) {
            console.error('Fehler beim Laden des Sales-Pricings:', error);
          }
        }
      })
      .catch((error) => console.error('Fehler beim Laden des Artikels:', error));
  }
}, [itemId]);


// Telematik-Konfiguration für dieses Item laden
useEffect(() => {
  if (!itemId) {
    setTelematicsProviderId('');
    setTelematicsExternalUnitId('');
    setHasTelematicsConfig(false);
    return;
  }

  api.get(`/telematics/item/${itemId}`)
    .then(res => {
      const unit = res.data?.data || null;
      if (!unit) {
        setTelematicsProviderId('');
        setTelematicsExternalUnitId('');
        setHasTelematicsConfig(false);
        return;
      }

      setTelematicsProviderId(
        unit.providerId != null ? String(unit.providerId) : ''
      );
      setTelematicsExternalUnitId(unit.externalUnitId || '');
      setHasTelematicsConfig(true);
    })
    .catch(err => {
      console.error('Fehler beim Laden der Telematik-Konfiguration:', err);
    });
}, [itemId]);


// Einheiten für die Preise laden
useEffect(() => {
  const fetchUnits = async () => {
    try {
      const response = await api.get('/units');
      setUnits(response.data);
    } catch (error) {
      console.error('Fehler beim Laden der Einheiten:', error);
    }
  };

  fetchUnits();
}, []);

// Preise für den zugeordneten Maschinentyp laden
useEffect(() => {
  if (machineTypeId) {
    api
      .get(`/typepricings/${machineTypeId}`)
      .then(response => setPrices(response.data))
      .catch(error => console.error('Fehler beim Laden der Preise:', error));
  }
}, [machineTypeId]);

// Versicherungspreis speichern
const saveInsurancePricing = () => {
  if (!itemId) {
    alert('Der Artikel muss zuerst gespeichert werden!');
    return;
  }

   // Komma durch Punkt ersetzen, um parseFloat korrekt zu machen
  const normalized = insurancePercentage.replace(',', '.');
  const percentageValue = parseFloat(normalized) || 0;

  const insuranceData = {
    itemId,
    percentage: percentageValue,
    unitId: getUnitIdByName("Prozent"),
  };

  // Prüfen, ob der Eintrag aktualisiert oder neu erstellt werden soll
  if (insurancePricingId) {
    api
      .put(`/insurancepricings/${insurancePricingId}`, insuranceData)
      .then(() => {
        alert('Versicherungspreis erfolgreich aktualisiert!');
      })
      .catch((error) => console.error('Fehler beim Aktualisieren des Versicherungspreises:', error));
  } else {
    api
      .post('/insurancepricings', insuranceData)
      .then((response) => {
        setInsurancePricingId(response.data.id); // ID des neuen Eintrags speichern
        alert('Versicherungspreis erfolgreich gespeichert!');
      })
      .catch((error) => console.error('Fehler beim Speichern des Versicherungspreises:', error));
  }
};

const saveInsuranceFixedPricing = () => {
  if (!itemId) {
    alert('Der Artikel muss zuerst gespeichert werden!');
    return;
  }
  const amount = parseFloat(insuranceFixedAmount) || 0;
  const data = {
    itemId,
    fixedAmount: amount,
    unitId: getUnitIdByName("Tag"),
    // unitId: ID der Einheit "Tage" aus deiner Units-Tabelle, falls benötigt (z. B. unitId: 2)
  };

  if (insuranceFixedPricingId) {
    api
      .put(`/insurancepricings/${insuranceFixedPricingId}`, data)
      .then(() => alert('Fixbetrag erfolgreich aktualisiert!'))
      .catch((error) => console.error('Fehler beim Aktualisieren des Fixbetrags:', error));
  } else {
    api
      .post('/insurancepricings', data)
      .then((response) => {
        setInsuranceFixedPricingId(response.data.id);
        alert('Fixbetrag erfolgreich gespeichert!');
      })
      .catch((error) => console.error('Fehler beim Speichern des Fixbetrags:', error));
  }
};  
  

const handleSubmit = async (e) => {
  e.preventDefault();

  const isNew = !itemId;

  const itemPayload = {
    name,
    itemType,
    machineTypeId,
    manufacturer,
    manufacturerType,
    liftworkerId,
    liftworkerType,
    accountingCodeId: accountingCodeId === '' ? null : parseInt(accountingCodeId, 10),
    storageLocationId: storageLocationId === '' ? null : parseInt(storageLocationId, 10),
    maxWorkingHeight,
    basketArm,
    totalWeight,
    yearOfManufacture,
    serialNumber,
    description,
    visibleInCalendar,
    foreignArticle,
    deactivated,
    productGroupId,
    motorTypeId,
    uvvInspection,
    tuvInspection,
    tachoInspection,
    asuInspection,
    otherInspection,
    technicalDataOwner,
    technicalDataManufacturer,
    technicalDataSale,
    userManual,
    errorCodes,
    licensePlate,
    inventoryNumber,
    cargo,
    splitCargo,
    driverLicense,
    calcCostPerDay,
    exportLO,
    netPriceLO: netPriceLO ?? 0,
    notesLO,
    picLO,
    locationLO,
    exportSRR,
    netPricePerDaySRR1: netPricePerDaySRR1 ?? 0,
    netPricePerDaySRR2: netPricePerDaySRR2 ?? 0,
    netPricePerDaySRR3: netPricePerDaySRR3 ?? 0,
    netPricePerDaySRR4: netPricePerDaySRR4 ?? 0,
    netPricePerHourSRR: netPricePerHourSRR ?? 0,
    notesSRR,
    picSRR,
    locationSRR,
    picHP,
    qsv1Url,
    qsv2Url,
    qsv3Url,
    uvvInspectionUrl,
    tuvInspectionUrl,
    tachoInspectionUrl,
    asuInspectionUrl,
    otherInspectionUrl,
    workinghour: workinghour === '' ? null : parseFloat(workinghour),
    conditionId: conditionId === '' ? null : parseInt(conditionId, 10),
    notes,
    // --- NEU: Finanz-/Meta-Felder ---
acquisitionCost: acquisitionCost === '' ? null : parseFloat(acquisitionCost),
insuranceCost: insuranceCost === '' ? null : parseFloat(insuranceCost),
kfzTax: kfzTax === '' ? null : parseFloat(kfzTax),
budgetPricePerDay: budgetPricePerDay === '' ? null : parseFloat(budgetPricePerDay),
costPricePerDay: costPricePerDay === '' ? null : parseFloat(costPricePerDay),
stockQuantity: stockQuantity === '' ? null : parseInt(stockQuantity, 10),
financingCostPerMonth: financingCostPerMonth === '' ? null : parseFloat(financingCostPerMonth),
financingUntil: financingUntil || null, // bereits YYYY-MM-DD vom Date-Input
color: (color && !isWhite(color)) ? color : null,  // ⬅️ NEU
  };
console.log('Vor dem API-Call, ich sende:', itemPayload);
  try {
    // 1) Item anlegen oder updaten
    let savedItemId;
    if (isNew) {
      const { data } = await api.post('/items', itemPayload);
      if (!data?.id) {
        console.error('Keine ID im POST-Antwortpayload:', data);
        throw new Error('Beim Anlegen des Items wurde keine ID zurückgeliefert');
      }
      savedItemId = data.id;
    } else {
      await api.put(`/items/${itemId}`, itemPayload);
      savedItemId = itemId;
    }

// 5) Telematik-Konfiguration speichern/entfernen
    if (telematicsProviderId && telematicsExternalUnitId) {
      // Upsert Telematik-Einheit
      await api.put(`/telematics/item/${savedItemId}`, {
        providerId: parseInt(telematicsProviderId, 10),
        externalUnitId: telematicsExternalUnitId,
        // optional: isActive, installedAt, removedAt, notes
      });
      setHasTelematicsConfig(true);
    } else if (hasTelematicsConfig && (!telematicsProviderId || !telematicsExternalUnitId)) {
      // Wenn zuvor eine Konfig existierte und jetzt "geleert" wurde -> löschen
      await api.delete(`/telematics/item/${savedItemId}`);
      setHasTelematicsConfig(false);
    }

    alert('Artikel gespeichert!');
    navigate('/itemlist');
  } catch (err) {
    console.error('Fehler beim Speichern/Exportieren:', err);
    alert('Fehler beim Speichern des Artikels');
  }
};


  return (
    <form className="form" onSubmit={handleSubmit}>
      {/* Formularüberschrift: Bearbeiten oder Hinzufügen */}

  
      {/* Artikelname linksbündig */}
      <div className="item-name">
      <Helmet>
        <title>Artikel bearbeiten</title>
        <meta name="description" content="Artikel bearbeiten" />
      </Helmet>
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Artikelname"
          required
          style={{ fontSize: '48px', padding: '10px', fontWeight: 'normal' }}
        />
      </div>
  
      {/* Artikelart / Lagerort */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '12px', marginBottom: '20px' }}>
        <select
          id="itemType"
          value={itemType}
          onChange={(e) => setItemType(e.target.value)}
          style={{ width: '100%', padding: '10px', margin: '0px', fontSize: '1em' }}
        >
          <option value="" disabled>Artikelart auswählen</option>
          <option value="rental">Mietartikel</option>
          <option value="sale">Verkaufsartikel</option>
          <option value="insurance">Versicherungsartikel (Prozent) </option>
          <option value="insuranceFixed">Versicherung (Fix/Tag)</option>
          <option value="transport">Transportartikel</option>
          <option value="sparePart">Ersatzteil</option>
          <option value="service">Serviceartikel</option>
          <option value="transportvehicle">Transportfahrzeug</option>
          <option value="inventory">Inventar</option>
        </select>

        <select
          id="storageLocationId"
          value={storageLocationId}
          onChange={(e) => setStorageLocationId(e.target.value)}
          style={{ width: '100%', padding: '10px', margin: '0px', fontSize: '1em' }}
        >
          <option value="">Lagerort auswählen</option>
          {storageLocations.map(location => (
            <option
              key={location.id}
              value={location.id}
              disabled={location.isActive === false && String(storageLocationId) !== String(location.id)}
            >
              {location.name}{location.isActive === false ? ' (inaktiv)' : ''}
            </option>
          ))}
        </select>
      </div>
  
      {/* Tabs */}
<div className="tabs">
  {[
    { id: 'general', label: 'Allgemein' },
    { id: 'pricing', label: 'Preise' },
    { id: 'links', label: 'Verknüpfungen' },
    { id: 'inspections', label: 'Prüfungen' },
    { id: 'technicalData', label: 'Techn. Daten' },
    { id: 'telematics',   label: 'Telematik' },
    
  ].map((tab) => (
    <React.Fragment key={tab.id}>
      {tab.id === 'general' && (
        <span
          style={{
            display: 'inline-block',
            width: 32,            // reservierter Platz (ändert Tabs nicht)
            height: 32,
            position: 'relative',
            overflow: 'visible',
            marginRight: 12,
            verticalAlign: 'middle',
          }}
        >
          {(() => {
            // Produktgruppen-Farbe holen
            const pg = productGroups.find(pg => String(pg.id) === String(productGroupId));
            const pgColor = pg?.color || '#ffffff';

            // Effektive Farbe (Item-Override oder PG-Farbe)
            const effectiveColor = (color && !/^#?f{3,8}$/i.test((color || '').replace('#', '')))
              ? color
              : pgColor;

            return (
              <input
                type="color"
                value={effectiveColor}
                onChange={e => {
                  const v = e.target.value;
                  // „weiß“ bedeutet: kein Override -> leeren
                  if (/^#?f{3,8}$/i.test((v || '').replace('#', ''))) {
                    setColor('');
                  } else {
                    setColor(v);
                  }
                }}
                title="Farbe wählen (leer = Produktgruppen-Farbe)"
                style={{
                  position: 'absolute',
                  left: 0,
                  top: '70%',
                  transform: 'translateY(-50%) scale(1.35)', // Größe des Farbfelds (Tabs bleiben gleich)
                  transformOrigin: 'left center',
                  width: 32,
                  height: 32,
                  border: 'none',
                  background: 'none',
                  padding: 0,
                  cursor: 'pointer',
                }}
              />
            );
          })()}
        </span>
      )}
      <button
        type="button"
        className={`tab-button ${activeTab === tab.id ? 'active' : ''}`}
        onClick={() => setActiveTab(tab.id)}
        aria-pressed={activeTab === tab.id}
      >
        {tab.label}
      </button>
    </React.Fragment>
  ))}
</div>



  
      {/* Allgemein */}
      {activeTab === 'general' && (
        <div className="form-row">
          {/* Linke Spalte */}
          <div className="col">
            <input
               type="number"
               value={maxWorkingHeight === null ? '' : maxWorkingHeight} // Wenn null, zeige ein leeres Feld
               onChange={(e) => {
                 const value = e.target.value;
                 setMaxWorkingHeight(value === '' ? null : parseFloat(value)); // Setze null, wenn das Feld geleert wird
               }}
               placeholder="Max. Arbeitshöhe (m)"
            />
            <select
              value={machineTypeId ?? ''}
              onChange={(e) => setMachineTypeId(e.target.value === "" ? null : e.target.value) }
              className="machine-type-select" // Hinzugefügte Klasse
            >
              <option value="" >Maschinentyp auswählen</option>
              {machineTypes.map((type) => (
                <option key={type.id} value={type.id}>
                  {type.name}
                </option>
              ))}
            </select>
            <select
              value={productGroupId ?? ''}
              onChange={(e) => setProductGroupId(e.target.value)}
              className="product-group-select" // Hinzugefügte Klasse

            >
              <option value="" disabled>Produktgruppe auswählen</option>
              {productGroups.map(group => (
                <option key={group.id} value={group.id}>
                  {group.name}
                </option>
              ))}
            </select>
            <select
              value={motorTypeId ?? ''}
              onChange={(e) => setMotorTypeId(e.target.value)}
              className="motor-type-select" // Hinzugefügte Klasse
 
            >
              <option value="" disabled>Motorisierung auswählen</option>
              {motorTypes.map(motor => (
                <option key={motor.id} value={motor.id}>
                  {motor.name}
                </option>
              ))}
            </select>
            <input
              type="text"
              value={licensePlate || ''}
              onChange={(e) => setLicensePlate(e.target.value)}
              placeholder="Kennzeichen"
            />
          </div>
  
          {/* Mittlere Spalte */}
          <div className="col">
            <input
              type="text"
              value={manufacturer || ''}
              onChange={(e) => setManufacturer(e.target.value)}
              placeholder="Hersteller"
            />
            <input
              type="text"
              value={manufacturerType || ''}
              onChange={(e) => setManufacturerType(e.target.value)}
              placeholder="Hersteller-Typ"
            />
            <input
              type="number"
              value={totalWeight || ''} // Konvertiert `null` zu leerem String für React
              onChange={(e) => {
                const value = e.target.value;
                setTotalWeight(value === '' ? null : parseFloat(value));
              }}
              placeholder="Gesamtgewicht (kg)"
            />
            <input
              type="number"
              value={yearOfManufacture || ''} // Konvertiert `null` zu leerem String für React
              onChange={(e) => {
                const value = e.target.value;
                setYearOfManufacture(value === '' ? null : parseInt(value, 10));
              }}
              placeholder="Baujahr"
            />
            <input
              type="text"
              value={serialNumber || ''}
              onChange={(e) => setSerialNumber(e.target.value)}
              placeholder="Seriennummer"
            />
          </div>
  
          {/* Rechte Spalte */}
          <div className="col">
            <div style={{ display: 'flex', gap: '20px', alignItems: 'center', marginBottom: '10px' }}>
              <label>
                <input
                  type="checkbox"
                  checked={basketArm}
                  onChange={(e) => setBasketArm(e.target.checked)}
                />
                Korbarm
              </label>
              <label>
                <input
                  type="checkbox"
                  checked={visibleInCalendar}
                  onChange={(e) => setVisibleInCalendar(e.target.checked)}
                />
                Kalender
              </label>
              <label>
                <input
                  type="checkbox"
                  checked={foreignArticle}
                  onChange={(e) => setForeignArticle(e.target.checked)}
                />
                Fremdartikel
              </label>
              <label>
                <input
                  type="checkbox"
                  checked={deactivated}
                  onChange={(e) => setDeactivated(e.target.checked)}
                />
                deaktiv
              </label>
            </div>
            <textarea
              value={description || ''}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Beschreibung"
              rows={4}
            />
              <textarea
              value={notes || ''}
              onChange={(e) => setNotes(e.target.value)}
              placeholder="interne Notitz"
              rows={4}
              style={{ marginTop: '20px' }}
            />
          </div>
        </div>
      )}
      {/* Preise */}
{activeTab === 'pricing' && (
  <div className="pricing-tab">
    <div className="form-row">
      {/* Linke Spalte */}
      <div className="col">
        {itemType === 'insurance' && (
          <div>
            <label htmlFor="insurancePercentage">Versicherungsprozentsatz (%):</label>
            <input
              id="insurancePercentage"
              type="text"    
              value={insurancePercentage || ''}
              onChange={(e) => setInsurancePercentage(e.target.value)}
              placeholder="Versicherungsprozentsatz eingeben"
            />
            <button onClick={saveInsurancePricing}>Speichern</button>
          </div>
        )}

{itemType === 'insuranceFixed' && (
  <div>
    <label htmlFor="insuranceFixedAmount">Fixbetrag pro Tag (€):</label>
    <input
      id="insuranceFixedAmount"
      type="number"
      value={insuranceFixedAmount || ''}
      onChange={(e) => setInsuranceFixedAmount(e.target.value)}
      placeholder="Fixbetrag pro Tag eingeben"
      step="0.01"
      min="0"
    />
    <button onClick={saveInsuranceFixedPricing}>Speichern</button>
  </div>
)}

        {itemType === 'transport' && (
          <div>
            <h3>Neue Preisstaffel hinzufügen</h3>
            <select
              value={newTransportUnitId}
              onChange={(e) => setNewTransportUnitId(e.target.value)}
              style={{ marginTop: '10px', marginLeft: '0' }}
            >
              <option value="" disabled>Einheit auswählen</option>
              {units.map((unit) => (
                <option key={unit.id} value={unit.id}>
                  {unit.name}
                </option>
              ))}
            </select>
            <input
              type="number"
              value={newTransportPrice || ''}
              onChange={(e) => setNewTransportPrice(e.target.value)}
              placeholder="Preis/Einheit"
              style={{ marginTop: '10px' }}
            />
            <button onClick={addTransportPrice} style={{ marginTop: '10px' }}>
              Hinzufügen
            </button>
          </div>
        )}
      </div>

      

      {['sale', 'sparePart', 'service'].includes(itemType) && (
  <div className="col">
    <h3>Sales-Pricing</h3>
    
    {/* Hinzufügen eines neuen Sales-Pricings */}
    <div style={{ marginBottom: '20px' }}>
      <h4>Neues Sales-Pricing hinzufügen</h4>
      <select
        value={newSalesUnitId}
        onChange={(e) => setNewSalesUnitId(e.target.value)}
        style={{ width: '100%', padding: '10px', marginBottom: '10px', marginLeft:'0px'  }}
      >
        <option value="" disabled>Einheit auswählen</option>
        {units.map((unit) => (
          <option key={unit.id} value={unit.id}>
            {unit.name}
          </option>
        ))}
      </select>
      <input
        type="number"
        value={newSalesMinQuantity}
        onChange={(e) => setNewSalesMinQuantity(e.target.value)}
        placeholder="Minimale Menge"
        style={{ width: '100%', padding: '10px', marginBottom: '10px' }}
      />
      <input
        type="number"
        value={newSalesMaxQuantity}
        onChange={(e) => setNewSalesMaxQuantity(e.target.value)}
        placeholder="Maximale Menge"
        style={{ width: '100%', padding: '10px', marginBottom: '10px' }}
      />
      <input
        type="number"
        value={newSalesPrice}
        onChange={(e) => setNewSalesPrice(e.target.value)}
        placeholder="Preis pro Einheit (€)"
        style={{ width: '100%', padding: '10px', marginBottom: '10px' }}
      />
      <button type="button" onClick={addSalesPricing} style={{ padding: '10px 20px' }}>
        Hinzufügen
      </button>
    </div>

    {/* Tabelle der Sales-Pricings */}
    <div>
      <h4>Bestehende Sales-Pricings</h4>
      {salesPricings.length > 0 ? (
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <th>Einheit</th>
              <th>Min. Menge</th>
              <th>Max. Menge</th>
              <th>Preis/Einheit (€)</th>
              <th>Aktionen</th>
            </tr>
          </thead>
          <tbody>
            {salesPricings.map((price) => (
              <tr key={price.id} style={{ borderBottom: '1px solid #ccc' }}>
                <td>
                  {editingSalesPriceId === price.id ? (
                    <select
                      value={editableSalesUnitId}
                      onChange={(e) => setEditableSalesUnitId(e.target.value)}
                      style={{ width: '100%', padding: '5px', marginLeft: '0px', marginTop:'0px'  }}
                    >
                      <option value="" disabled>Einheit auswählen</option>
                      {units.map((unit) => (
                        <option key={unit.id} value={unit.id}>
                          {unit.name}
                        </option>
                      ))}
                    </select>
                  ) : (
                    units.find((unit) => unit.id === price.unitId)?.name || '-'
                  )}
                </td>
                <td>
                  {editingSalesPriceId === price.id ? (
                    <input
                      type="number"
                      value={editableSalesMinQuantity}
                      onChange={(e) => setEditableSalesMinQuantity(e.target.value)}
                      style={{ width: '100%', padding: '5px' }}
                    />
                  ) : (
                    price.minQuantity
                  )}
                </td>
                <td>
                  {editingSalesPriceId === price.id ? (
                    <input
                      type="number"
                      value={editableSalesMaxQuantity}
                      onChange={(e) => setEditableSalesMaxQuantity(e.target.value)}
                      style={{ width: '100%', padding: '5px' }}
                    />
                  ) : (
                    price.maxQuantity
                  )}
                </td>
                <td>
                  {editingSalesPriceId === price.id ? (
                    <input
                      type="number"
                      value={editableSalesPrice}
                      onChange={(e) => setEditableSalesPrice(e.target.value)}
                      style={{ width: '120%', padding: '5px' }}
                    />
                  ) : (
                    formatPrice(price?.pricePerUnit)
                  )}
                </td>
                <td>
                  {editingSalesPriceId === price.id ? (
                    <>
                      <button
                        type="button"
                        onClick={() => saveSalesPricing(price.id)}
                        style={{
                fontSize: '15px',
                padding: '5px 10px',
                background: '#28a745', // Rot für Löschen
                color: '#fff',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
                marginRight: '5px',
              }}
                      >
                        Speichern
                      </button>
                      <button type="button" onClick={cancelEditSalesPricing}
                      style={{
                fontSize: '15px',
                padding: '5px 10px',
                background: '#ababacff', // Rot für Löschen
                color: '#fff',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
                marginRight: '5px',
              }}>
                        Abbrechen
                      </button>
                    </>
                  ) : (
                    <>
                      <button
                        type="button"
                        onClick={() => startEditSalesPricing(price.id, price.unitId, price.minQuantity, price.maxQuantity, price.pricePerUnit)}
                        style={{
                fontSize: '15px',
                padding: '5px 10px',
                background: '#007bff', // Rot für Löschen
                color: '#fff',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
                marginRight: '5px',
              }}
                      >
                        Bearbeiten
                      </button>
                      <button type="button" onClick={() => deleteSalesPricing(price.id)}
                        style={{
                fontSize: '15px',
                padding: '5px 10px',
                background: '#dc3545', // Rot für Löschen
                color: '#fff',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer'
              }}>
                        Löschen
                      </button>
                    </>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p>Keine Sales-Pricings verfügbar.</p>
      )}
    </div>
  </div>
)}


      {/* Mittlere Spalte */}
      <div className="col">
        {itemType === 'rental' && (
          <div>
            <h3>Mietpreisstaffel</h3>
            {prices.length > 0 ? (() => {
  const sorted = [...prices].sort((a, b) =>
    (a.unitId - b.unitId) ||
    (a.minQuantity - b.minQuantity) ||
    ((a.maxQuantity ?? Number.POSITIVE_INFINITY) - (b.maxQuantity ?? Number.POSITIVE_INFINITY))
  );

  const rows = [];
  let lastUnitId = null;
  sorted.forEach((p) => {
    if (p.unitId !== lastUnitId) {
      rows.push({ _header: true, unitId: p.unitId, key: `h-${p.unitId}-${p.id}` });
      lastUnitId = p.unitId;
    }
    rows.push(p);
  });

  const unitName = (uid) => units.find(u => u.id === uid)?.name || '-';

  return (
    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
      <thead>
        <tr>
          <th>Min</th>
          <th>Max</th>
          <th>Einheit</th>
          <th>€ / Einheit</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((row) => {
          if (row._header) {
            return (
              <tr key={row.key} style={{ background: '#f5f5f5' }}>
                <td colSpan={4} style={{ fontWeight: 600, padding: '6px 8px' }}>
                  {unitName(row.unitId)}
                </td>
              </tr>
            );
          }
          return (
            <tr key={row.id} style={{ borderBottom: '1px solid #e5e5e5' }}>
              <td>{row.minQuantity}</td>
              <td>{row.maxQuantity}</td>
              <td>{unitName(row.unitId)}</td>
              <td>{Number(row.pricePerUnit).toFixed(2).replace('.', ',')}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
})() : (
  <p>Keine Mietpreise vorhanden.</p>
)}

          </div>
        )}
      </div>

      {/* Rechte Spalte */}
      <div className="col">
        {/* Rechte Spalte leer */}
      </div>
    </div>

    {/* Tabelle für Transportpreise mittig ausrichten */}
    {itemType === 'transport' && (
      <div className="form-row" style={{ justifyContent: 'center', display: 'flex' }}>
        <div style={{ width: '80%' }}>
          <h3 style={{ textAlign: 'center' }}>Transportpreisstaffel</h3>
          {transportPrices.length > 0 ? (
            <table style={{ margin: '0 auto' }}>
              <thead>
                <tr>
                  <th>Einheit</th>
                  <th>Preis/Einheit (€)</th>
                  <th>Aktionen</th>
                </tr>
              </thead>
              <tbody>
                {transportPrices.map((price) => (
                  <tr key={price.id}>
                    <td>{units.find((unit) => unit.id === price.unitId)?.name || '-'}</td>
                    <td>
                      {editingPriceId === price.id ? (
                        <input
                          type="number"
                          value={editablePrice || ''}
                          onChange={(e) => setEditablePrice(e.target.value)}
                          placeholder="Neuer Preis"
                        />
                      ) : (
                        formatPrice(price?.pricePerUnit)
                      )}
                    </td>
                    <td>
                      {editingPriceId === price.id ? (
                        <>
                          <button type="button" onClick={() => saveTransportPrice(price.id)}>Speichern</button>
                          <button type="button" onClick={cancelEdit}>Abbrechen</button>
                        </>
                      ) : (
                        <>
                          <button type="button" onClick={() => startEdit(price.id, price.pricePerUnit)}>Bearbeiten</button>
                          <button type="button" onClick={() => deleteTransportPrice(price.id)}>Löschen</button>
                        </>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p style={{ textAlign: 'center' }}>Keine Transportpreise verfügbar.</p>
          )}
        </div>
      </div>
    )}
  </div>
)}


      


{/* Techn. Daten */}
{activeTab === 'technicalData' && (
  <div className="form-row lw-import-technical">
    {/* Linke Spalte */}
    <div className="col">
      {/* Techn. Daten (Verm) */}
      <LiftworkerImportFeedback control={lwImport} />
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <input
          type="text"
          value={technicalDataOwner || ''}
          onChange={(e) => setTechnicalDataOwner(e.target.value)}
          placeholder="Techn. Daten (Verm)"
          style={{ flex: 1 }}
        />
        <LiftworkerImportButton control={lwImport} field="technicalDataOwner" onSelect={setTechnicalDataOwner} />
        <button type="button" onClick={openTechnicalDataUrl} style={{
                      fontSize: '15px',
                      padding: '10px 10px',
                      marginLeft: '10px',
                      color: '#fff',
                      marginTop: '-10px'
                    }} >
          TD Verm
        </button>
      </div>
      
      {/* Techn. Daten (Herst) */}
      <div style={{ display: 'flex', alignItems: 'center', marginTop: '0px' }}>
        <input
          type="text"
          value={technicalDataManufacturer || ''}
          onChange={(e) => setTechnicalDataManufacturer(e.target.value)}
          placeholder="Techn. Daten (Herst)"
          style={{ flex: 1 }}
        />
        <LiftworkerImportButton control={lwImport} field="technicalDataManufacturer" onSelect={setTechnicalDataManufacturer} />
        <button type="button" onClick={openTechnicalDataManufacturerUrl} style={{
                      fontSize: '15px',
                      padding: '10px 10px',
                      marginLeft: '10px',
                      color: '#fff',
                      marginTop: '-10px'
                    }} >
          TD Herst
        </button>
      </div>

      {/* Techn. Daten (Verkauf) */}
      <div style={{ display: 'flex', alignItems: 'center', marginTop: '0px' }}>
        <input
          type="text"
          value={technicalDataSale || ''}
          onChange={(e) => setTechnicalDataSale(e.target.value)}
          placeholder="Techn. Daten (Verkauf)"
          style={{ flex: 1 }}
        />
        <LiftworkerImportButton control={lwImport} field="technicalDataSale" onSelect={setTechnicalDataSale} />
        <button type="button" onClick={openTechnicalDataSaleUrl} style={{
                      fontSize: '15px',
                      padding: '10px 10px',
                      marginLeft: '10px',
                      color: '#fff',
                      marginTop: '-10px'
                    }} >
          TD Verk.
        </button>
      </div>

      {/* Bedienungsanleitung */}
      <div style={{ display: 'flex', alignItems: 'center', marginTop: '0px' }}>
        <input
          type="text"
          value={userManual || ''}
          onChange={(e) => setUserManual(e.target.value)}
          placeholder="Bedienungsanleitung"
          style={{ flex: 1 }}
        />
        <LiftworkerImportButton control={lwImport} field="userManual" onSelect={setUserManual} />
        <button type="button" onClick={openUserManualUrl} style={{
                      fontSize: '15px',
                      padding: '10px 10px',
                      marginLeft: '10px',
                      color: '#fff',
                      marginTop: '-10px'
                    }} >
          Manual..
        </button>
      </div>

      {/* Fehlercodes */}
      <div style={{ display: 'flex', alignItems: 'center', marginTop: '0px' }}>
        <input
          type="text"
          value={errorCodes || ''}
          onChange={(e) => setErrorCodes(e.target.value)}
          placeholder="Fehlercodes"
          style={{ flex: 1 }}
        />
        <LiftworkerImportButton control={lwImport} field="errorCodes" onSelect={setErrorCodes} />
        <button type="button" onClick={openErrorCodesUrl} style={{
                      fontSize: '15px',
                      padding: '10px 10px',
                      marginLeft: '10px',
                      color: '#fff',
                      marginTop: '-10px'
                    }} >
          Err-Code
        </button>
      </div>
{/* qsv1Url */}
<div style={{ display: 'flex', alignItems: 'center' }}>
        <input
          type="text"
          value={qsv1Url || ''}
          onChange={(e) => setQsv1Url(e.target.value)}
          placeholder="Qsv1Url"
          style={{ flex: 1 }}
        />
        <LiftworkerImportButton control={lwImport} field="qsv1Url" onSelect={setQsv1Url} />
        <button type="button" onClick={openQsv1Url} style={{
                      fontSize: '15px',
                      padding: '10px 10px',
                      marginLeft: '10px',
                      color: '#fff',
                      marginTop: '-10px'
                    }} >
          QSV_01
        </button>
      </div>
      {/* qsv2Url */}
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <input
          type="text"
          value={qsv2Url || ''}
          onChange={(e) => setQsv2Url(e.target.value)}
          placeholder="Qsv2Url"
          style={{ flex: 1 }}
        />
        <LiftworkerImportButton control={lwImport} field="qsv2Url" onSelect={setQsv2Url} />
        <button type="button" onClick={openQsv2Url} style={{
                      fontSize: '15px',
                      padding: '10px 10px',
                      marginLeft: '10px',
                      color: '#fff',
                      marginTop: '-10px'
                    }} >
          QSV_02
        </button>
      </div>
      {/* qsv3Url */}
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <input
          type="text"
          value={qsv3Url || ''}
          onChange={(e) => setQsv3Url(e.target.value)}
          placeholder="Qsv3Url"
          style={{ flex: 1 }}
        />
        <LiftworkerImportButton control={lwImport} field="qsv3Url" onSelect={setQsv3Url} />
        <button type="button" onClick={openQsv3Url} style={{
                      fontSize: '15px',
                      padding: '10px 10px',
                      marginLeft: '10px',
                      color: '#fff',
                      marginTop: '-10px'
                    }} >
          QSV_03
        </button>
      </div>
      {/* picHP (Titelbild HP) */}
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <input
          type="text"
          value={picHP || ''}
          onChange={(e) => setPicHP(e.target.value)}
          placeholder="pic (Liftworker Titelbild URL)"
          style={{ flex: 1 }}
        />
        <LiftworkerImportButton control={lwImport} field="picHP" onSelect={setPicHP} />
        <button
          type="button"
          onClick={openPicHPUrl}
          style={{
            fontSize: '15px',
            padding: '10px 10px',
            marginLeft: '10px',
            color: '#fff',
            marginTop: '-10px'
          }}
        >
          PIC_HP
        </button>
      </div>



    </div>
     {/* Mittlere Spalte */}
     <div className="col">
            <input
              type="text"
              value={inventoryNumber || ''}
              onChange={(e) => setInventoryNumber(e.target.value)}
              placeholder="Inventarnummer"
            />
            <input
               type="number"
               value={cargo === null ? '' : cargo} // Wenn null, zeige ein leeres Feld
               onChange={(e) => {
                 const value = e.target.value;
                 setCargo(value === '' ? null : parseFloat(value)); // Setze null, wenn das Feld geleert wird
               }}
               placeholder="max. Zuladung (kg)"
            />
            <input
               type="number"
               value={splitCargo === null ? '' : splitCargo} // Wenn null, zeige ein leeres Feld
               onChange={(e) => {
                 const value = e.target.value;
                 setSplitCargo(value === '' ? null : parseFloat(value)); // Setze null, wenn das Feld geleert wird
               }}
               placeholder="geteilte Ladung (kg)"
            />
            <input
              type="text"
              value={driverLicense || ''}
              onChange={(e) => setDriverLicense(e.target.value)}
              placeholder="Fahrerlaubnisklasse"
            />
            <input
  type="number"
  value={workinghour}
  onChange={e => setWorkinghour(e.target.value)}
  placeholder="Betriebsstunden"
/>


        
      </div>

      {/* Rechte Spalte */}
      <div className="col">
  <input
    type="number"
    value={calcCostPerDay || ''}
    onChange={(e) => setcalcCostPerDay(e.target.value)}
    placeholder="kalk. Kosten in € pro Arbeitstag"
  />
  <input
    type="number"
    value={acquisitionCost}
    onChange={(e) => setAcquisitionCost(e.target.value)}
    placeholder="Anschaffungskosten (€)"
    step="0.01"
    min="0"
    style={{ marginTop: '0px' }}
  />

  <input
    type="number"
    value={insuranceCost}
    onChange={(e) => setInsuranceCost(e.target.value)}
    placeholder="Versicherung (€ / Mon)"
    step="0.01"
    min="0"
  />

  <input
    type="number"
    value={kfzTax}
    onChange={(e) => setKfzTax(e.target.value)}
    placeholder="KFZ-Steuer (€ / Jahr)"
    step="0.01"
    min="0"
  />

  <input
    type="number"
    value={budgetPricePerDay}
    onChange={(e) => setBudgetPricePerDay(e.target.value)}
    placeholder="Budgetpreis / Tag (€)"
    step="0.01"
    min="0"
  />

  <input
    type="number"
    value={costPricePerDay}
    onChange={(e) => setCostPricePerDay(e.target.value)}
    placeholder="Einstandspreis / Tag (€)"
    step="0.01"
    min="0"
  />

  <input
    type="number"
    value={stockQuantity}
    onChange={(e) => setStockQuantity(e.target.value)}
    placeholder="Bestand (Stück)"
    min="0"
  />

  <input
    type="number"
    value={financingCostPerMonth}
    onChange={(e) => setFinancingCostPerMonth(e.target.value)}
    placeholder="Finanzierungskosten / Mon (€)"
    step="0.01"
    min="0"
  />

<input
  type={showDateInput ? "date" : "text"}
  placeholder="Finanzierung bis (TT.MM.JJJJ)"
  value={
    financingUntil
      ? moment(financingUntil).format("DD.MM.YYYY")
      : "" // leer = zeigt placeholder
  }
  onFocus={e => {
    setShowDateInput(true); // aktiviert den Datepicker
    e.target.type = "date";
    if (e.target.showPicker) e.target.showPicker();
  }}
  onBlur={e => {
    if (!e.target.value) {
      setShowDateInput(false); // zurück zu Textmodus für Placeholder
    }
  }}
  onChange={e => {
    const iso = e.target.value; // "YYYY-MM-DD"
    setFinancingUntil(iso);     // speicher ISO im State
  }}
  style={{ width: "100%" }}
/>
</div>
  </div>
)}

{/* Neuer Export-Tab */}
{/* Telematik */}
{activeTab === 'telematics' && (
  <div className="form-row">
    {/* Linke Spalte */}
    <div className="col">
      <h3></h3>
      <select
        value={telematicsProviderId || ''}
        onChange={e => setTelematicsProviderId(e.target.value)}
        style={{ width: '100%', padding: '10px', marginBottom: '10px', marginLeft:'0px'  }}
      >
        <option value="">Telematik-Hersteller auswählen</option>
        {telematicsProviders.map(p => (
          <option key={p.id} value={p.id}>
            {p.name}
          </option>
        ))}
      </select>

      <input
        type="text"
        value={telematicsExternalUnitId || ''}
        onChange={e => setTelematicsExternalUnitId(e.target.value)}
        placeholder="Telematik-Box-ID / Unit-ID"
        style={{ width: '100%', padding: '10px', marginBottom: '10px' }}
      />

      
    </div>

    {/* Mittlere Spalte */}
    <div className="col">
      
    </div>

    {/* Rechte Spalte */}
    <div className="col">
      {/* aktuell leer, Platz für spätere Buttons: „Position abrufen“ etc. */}
    </div>
  </div>
)}



{/* Verknüpfungen */}
{activeTab === 'links' && (
  <div className="links-tab">
 
    <div className="form-row">
      {/* Linke Spalte */}
      <div className="col">
        <h3></h3>
        <Select
  id="newLinkItemId"
  name="newLinkItemId"
  options={articleOptions}
  onInputChange={handleArticleSearchChange}
  onChange={handleArticleChange}
  value={articleOptions.find(opt => opt.value === newLinkItemId) || null}
  className="select-box-article"
  isClearable
  placeholder="Artikel suchen..."
  styles={{ container: base => ({ ...base, width: '100%', marginBottom: 50, padding:  '10px 0px', zIndex: 11, }) }}
/>
        <button onClick={addLink} style={{ width: '50%', marginBottom: '20px', marginleft: '0px', fontSize: '1em' }}>
          Hinzufügen
        </button>
      </div>

      {/* Mittlere Spalte */}
      <div className="col">
        {/* Mittlere Spalte bleibt leer */}
      </div>

      {/* Rechte Spalte */}
      <div className="col">
     
        <input
          type="text"
          value={liftworkerId || ''}
          onChange={(e) => setLiftworkerId(e.target.value)}
          placeholder="Liftworker-ID"
          style={{ width: '100%', marginBottom: '10px' }}
        />
        <input
          type="text"
          value={liftworkerType || ''}
          onChange={(e) => setLiftworkerType(e.target.value)}
          placeholder="Liftworker-Typ"
          style={{ width: '100%' }}
        />
        <select
          value={accountingCodeId || ''}
          onChange={(e) => setAccountingCodeId(e.target.value)}
          style={{ width: '100%', marginLeft: '0', marginRight: '0', marginTop: '0', marginBottom: '15px' }}
        >
          <option value="">Buchungskonto auswählen</option>
          {accountingCodes.map((accountingCode) => (
            <option key={accountingCode.id} value={accountingCode.id}>
              {accountingCode.code}{accountingCode.name ? ` - ${accountingCode.name}` : ''}
            </option>
          ))}
        </select>
      </div>
    </div>

{/* Tabelle der Verknüpfungen über alle Spalten */}
 
{linkedItems.length > 0 ? (
      <table style={{ width: '100%', marginTop: '20px', borderCollapse: 'collapse' }}>
        <thead>
          <tr>
            <th>Artikel-ID</th>
            <th>Artikelname</th>
            <th>Artikeltyp</th>
       
            <th>Beschreibung</th>
            <th>Aktionen</th>
          </tr>
        </thead>
        <tbody>
          {linkedItems.map((link) => (
            <tr key={link.id}>
              <td>{link.linkedItem?.id || '-'}</td>
              <td>{link.linkedItem?.name || '-'}</td>
              <td>{link.linkedItem?.itemType || '-'}</td>

              <td>{link.linkedItem?.description || '-'}</td>
              <td>
                <button onClick={() => removeLink(link.id)}>Entfernen</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
) : (
  <p style={{ marginTop: '20px' }}>Keine verknüpften Artikel verfügbar.</p>
    )}
  </div>
)}





{/* Prüfungen */}
{activeTab === 'inspections' && (
  <div className="form-row">
    {/* Linke Spalte: Datumsauswahl mit Inline-Label */}
    <div className="col">
      {[
        { value: uvvInspection,   setter: setUvvInspection,   placeholder: 'Nächste UVV-Prüfung' },
        { value: tuvInspection,   setter: setTuvInspection,   placeholder: 'Nächste TÜV-Prüfung' },
        { value: tachoInspection, setter: setTachoInspection, placeholder: 'Nächste Tacho-Prüfung' },
        { value: asuInspection,   setter: setAsuInspection,   placeholder: 'Nächste ASU-Prüfung' },
        { value: otherInspection, setter: setOtherInspection, placeholder: 'Nächste sonstige Prüfung' },
      ].map(({ value, setter, placeholder }, idx) => {
        const dateId = `inspection-date-${idx}`;
        return (
          <div
            key={idx}
            style={{
              display: 'flex',
              alignItems: 'center',
              marginBottom: '1rem'
            }}
          >
             <label
              htmlFor={dateId}
              style={{
                width: '150px',        // feste Breite
                textAlign: 'right',    // rechtsbündig
                marginRight: '0.5rem',
                whiteSpace: 'nowrap',
                fontWeight: 500,
                
              }}
            >
              {placeholder}:
            </label>
            <input
              type="date"
              id={dateId}
              value={value || ''}
              onChange={e => setter(e.target.value || null)}
              style={{
                flex: 1,
                padding: '0.375rem 0.75rem',
                marginLeft: '40px',
              }}
            />
          </div>
        );
      })}
    </div>

    {/* Mittlere Spalte: leer */}
    <div className="col">
      {[
        { value: uvvInspectionUrl,   setter: setUvvInspectionUrl,   openFn: openUvvInspectionUrl,   placeholder: 'UVV-Prüfungs-URL' },
        { value: tuvInspectionUrl,   setter: setTuvInspectionUrl,   openFn: openTuvInspectionUrl,   placeholder: 'TÜV-Prüfungs-URL' },
        { value: tachoInspectionUrl, setter: setTachoInspectionUrl, openFn: openTachoInspectionUrl, placeholder: 'Tacho-Prüfungs-URL' },
        { value: asuInspectionUrl,   setter: setAsuInspectionUrl,   openFn: openAsuInspectionUrl,   placeholder: 'ASU-Prüfungs-URL' },
        { value: otherInspectionUrl, setter: setOtherInspectionUrl, openFn: openOtherInspectionUrl, placeholder: 'Sonstige Prüfungs-URL' },
      ].map(({ value, setter, openFn, placeholder }, idx) => {
        const urlId = `inspection-url-${idx}`;
        return (
          <div
            key={idx}
            style={{
              display: 'flex',
              alignItems: 'center',
              marginBottom: '1rem',
              
            }}
          >
            <input
              type="url"
              id={urlId}
              value={value || ''}
              onChange={e => setter(e.target.value)}
              placeholder={placeholder}
              style={{
                flex: 1,
                padding: '0.375rem 0.75rem',
                boxSizing: 'border-box',
                
                
              }}
            />
            <button
              type="button"
              onClick={openFn}
              style={{
                fontSize: '15px',
                padding: '10px',
                marginLeft: '0.5rem',
                color: '#fff',
                backgroundColor: '#007bff',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                marginTop: '-10px',
              
              }}
            >
              URL öffnen
            </button>
          </div>
        );
      })}
    </div>

    {/* Rechte Spalte: URL-Felder + „URL öffnen“-Buttons */}
    <div className="col"/>
      
  </div>
)}






<button type="submit" className="submit-button">
  {itemId ? 'Artikel aktualisieren' : 'Artikel hinzufügen'}
</button>

      <LiftworkerDocumentPicker control={lwImport} />
    </form>
  );
};

export default ItemForm;
